<script>
import { Bar, mixins } from 'vue-chartjs'
import { stringify } from 'flatted';

export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: {
    options: {
      type: Object,
      default() {
          return {
              responsive: true,
              rmaintainAspectRatio: false,
              legend: {
                  display: false
              },
              scales: {
                  yAxes: [
                      {
                          stacked: true,
                          gridLines: {
                              //display: false,
                              //drawOnChartArea: false,
                              drawBorder: false
                          },
                          ticks: {
                              beginAtZero: true,
                              callback: function (value) { if (Number.isInteger(value)) { return value; } },
                              //stepSize: 1
                          }
                      }
                  ],
                  xAxes: [
                      {
                          stacked: true,
                          categoryPercentage: 0.5,
                          barPercentage: 1,
                          gridLines: {
                              color: "rgba(0, 0, 0, 0)",
                          },
                          ticks: {
                              //display: false,
                          },
                          gridLines: {
                              display: false,
                              drawOnChartArea: false,
                              drawBorder: false
                          }
                      }
                  ]
              },
              tooltips: {
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                borderColor: '#628aba',
                borderWidth: 1,
                xPadding: 15,
                yPadding: 12,
                titleFontColor: "#333",
                titleSpacing: 4,
                bodyFontColor: "#333",
                displayColors: false,
            },
           }
       },
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
}
</script>